import api from "./api";

class OrganizationService {
  // async getDataPage(params) {
  //   const response = await api.get("/organization/branchs", { params });
  //   return response;
  // }

  async changeStatus(data) {
    return await this.updateOrCreateBranch(data);
  }

  async getAllBranch() {
    const response = await api.get("/organization/branchs/all");
    return response;
  }

  async getUnits(params) {
    const response = await api.get("/organization/units",{params:params});
    return response;
  }
  getDataPage(params) {
    return api.get('/organization/units/paginate',{params:params});
}

  async getUnitsSelectTree() {
    const response = await api.get("/organization/units-select-tree");
    return response;
  }
  async getUnitsDepartmentSelectTree() {
    const response = await api.get("/organization/units-department-tree");
    return response;
  }

  async getUnitTreeChart() {
    const response = await api.get("/organization/unit-tree");
    return response;
  }

  async updateOrCreateBranch(item) {
    if (item.id) {
      const response = await api.put(`/organization/branch/${item.id}`, item);
      return response;
    }
    const response = await api.post("/organization/branch", item);
    return response;
  }

  async findUnit(key) {
    const response = await api.get(`/organization/unit/${key}`);
    return response;
  }

  async countChidl(id) {
    const response = await api.get(`/organization/unit-sum-child/${id}`);
    return response;
  }

  async getOrganizationUnit(params) {
    const queryParams = params
      ? Object.keys(params)
          .map((k) => encodeURIComponent(k) + "=" + encodeURIComponent(params[k]))
          .join("&")
      : "";

    const response = await api.get(`/organization/unit?${queryParams}`);
    return response;
  }

  async updateOrCreateUnit(item) {
    if (item.id) {
      const response = await api.put(`/organization/unit/${item.id}`, item);
      return response;
    }
    const response = await api.post("/organization/unit", item);
    return response;
  }

  async destroy(id) {
    const response = await api.delete(`/organization/branch/${id}`);
    return response;
  }

  async destroyUnit(id) {
    const response = await api.delete(`/organization/unit/${id}`);
    return response;
  }

  async pause(item) {
    if (item.id) {
      const response = await api.put(`/organization/unit/${item.id}`, item);
      return response;
    }
  }

  async updateOrCreateJobPosition(item) {
    if (item.id) {
      const response = await api.put(`/organization/unit/${item.id}`, item);
      return response;
    }
    const response = await api.post("/organization/unit", item);
    return response;
  }
}

export default new OrganizationService();
